import * as React from "react";
import { Grid, GridColumn as Column } from "@progress/kendo-react-grid";
const PortfolioReview = ({
  data
}) => {
  return(
    <>
    <div>
    <div className="checkbox-group">
      <label><b>View by</b></label>
        <label><input type="checkbox" />All</label>
        <label><input type="checkbox" />Advised Billable</label>
        <label><input type="checkbox" />Advised Non-Billable</label>
        <label><input type="checkbox" />Non-Advised</label>
      </div><br></br>
      <div className="checkbox-group">
      <label><b>Advised Billable</b></label>       
      </div><br></br>
      <Grid style={{ height: "100%"}} data={data} scrollable={'scrollable'}>
        <Column field="Family" title="Family" />
        <Column field="MarketValue" title="MarketValue" />
        <Column field="MTD" title="MTD%" />
        <Column field="YTD" title="YTD%" />
      </Grid>
    <br></br>
    <div className="checkbox-group">
      <label><b>Advised Non-Billable</b></label>       
      </div><br></br>
      <Grid style={{ height: "100%"}} data={data} scrollable={'scrollable'}>
        <Column field="Family" title="Family" />
        <Column field="MarketValue" title="MarketValue" />
        <Column field="MTD" title="MTD%" />
        <Column field="YTD" title="YTD%" />
      </Grid>
    </div>
    </>
  )
};
export default PortfolioReview;